import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import i18n from '../../app/i18n';

import useCreateAccount from './useCreateAccount';
import Text from '../Text';
import { Button } from '../FormStyles';
import TextInput from '../FormStyles/TextInput.jsx';
import { useGetBoardInfo } from './data';

const alternativeHeaders = {
  header: i18n.t('createAccount:title'),
  tileCompletion: i18n.t('createAccount:convertUserTitle'),
};

const subTitle = (customBody, origin) => {
  if (customBody) {
    return customBody;
  } else if (origin === 'tileCompletion') {
    return i18n.t('createAccount:convertUserSubtitle');
  }
  return '';
};

const CreateAccount = ({ origin, setOpenCreateModal }) => {
  const { t } = useTranslation('createAccount');
  const { data = {} } = useGetBoardInfo();

  const {
    values,
    handleSubmit,
    handleChange,
    inputError,
    disabledSubmit,
    handleBlur,
  } = useCreateAccount();

  return (
    <FormWrapper>
      <Title>
        <Text variant="h5">
          {data.customHeader ? data.customHeader : alternativeHeaders[origin]}
        </Text>
      </Title>
      <Body>
        <Text variant="body2">{subTitle(data.customBody, origin)}</Text>
      </Body>
      <TextInput
        name="firstName"
        value={values.firstName}
        error={inputError('firstName')}
        onChange={handleChange}
        onBlur={handleBlur}
        m="16px 0 16px"
        label={t('firstName')}
        placeholder={t('firstNamePlaceholder')}
      />
      <TextInput
        name="lastName"
        value={values.lastName}
        error={inputError('lastName')}
        onChange={handleChange}
        onBlur={handleBlur}
        m="16px 0 16px"
        label={t('lastName')}
        placeholder={t('lastNamePlaceholder')}
      />
      <TextInput
        name="email"
        value={values.email}
        error={inputError('email')}
        onBlur={handleBlur}
        onChange={handleChange}
        m="0 0 16px"
        label={t('email')}
        placeholder={t('emailPlaceholder')}
      />
      <TextInput
        type="password"
        name="password"
        value={values.password}
        error={inputError('password')}
        onBlur={handleBlur}
        onChange={handleChange}
        m="0 0 16px"
        label={t('password')}
        placeholder={t('passwordPlaceholder')}
      />
      <TermsWrapper>
        <Text variant="small4" color="black.80">
          {t('termsText')}
        </Text>
        <Text
          variant="small4"
          color="primary.100"
          as="a"
          target="_blank"
          href={t('termsUrl')}
        >
          {t('termsLink')}
        </Text>
      </TermsWrapper>
      <ButtonGroup>
        <CancelButton
          variant="tertiary"
          onClick={() => setOpenCreateModal(false)}
        >
          {t('cancel')}
        </CancelButton>
        <CreateAccountButton
          variant="containedBlue"
          onClick={handleSubmit}
          disabled={disabledSubmit}
          title={disabledSubmit ? t('disabledBtn') : ''}
        >
          {t('title')}
        </CreateAccountButton>
      </ButtonGroup>
    </FormWrapper>
  );
};

export default CreateAccount;

CreateAccount.propTypes = {
  setOpenCreateModal: PropTypes.func,
  origin: PropTypes.string,
};

const FormWrapper = styled.div`
  width: 100%;
  padding: 20px;
  border-radius: 8px;
`;

const Title = styled.div`
  text-align: left;
`;

const Body = styled.div`
  margin-top: 16px;
  text-align: left;
`;

const TermsWrapper = styled.div`
  text-align: left;
  margin: 8px 0 16px;
`;

const ButtonGroup = styled.div`
  text-align: right;
`;

const CancelButton = styled(Button)`
  margin: 0;
`;

const CreateAccountButton = styled(Button)`
  margin: 0 0 0 10px;
`;
